import { Dispatch, FunctionComponent, SetStateAction, useContext } from 'react'
import { ThemeContext } from 'styled-components'

import Body3 from 'design-system/Typography/Body/Body3'

import StyledHr from 'components/GlobalStyles/Hr'
import CheckboxInput from 'components/GlobalStyles/Inputs/CheckboxInput'
import Spacer from 'components/Spacer'

import { ForSaleType, ForSaleTypeEnum } from '../types'

interface IProps {
  selectedForSaleTypes: ForSaleType[]
  setSelectedForSaleTypes: Dispatch<SetStateAction<ForSaleType[]>>
}

const ForSaleTypeSelectionInput: FunctionComponent<IProps> = ({
  selectedForSaleTypes,
  setSelectedForSaleTypes,
}) => {
  const theme = useContext(ThemeContext)

  const handleCheckboxChange = (value: ForSaleType) => {
    let newSelection = [...selectedForSaleTypes]

    if (selectedForSaleTypes.includes(value)) {
      newSelection = newSelection.filter(type => type !== value)
    } else {
      newSelection = [...selectedForSaleTypes, value]
    }

    setSelectedForSaleTypes(newSelection)
  }

  return (
    <>
      <Body3>Sale Status</Body3>
      <Spacer size={theme.spacings[8]} />
      <CheckboxInput
        name={ForSaleTypeEnum.forSale}
        checked={selectedForSaleTypes.includes(ForSaleTypeEnum.forSale)}
        onChange={() => handleCheckboxChange(ForSaleTypeEnum.forSale)}
        label={ForSaleTypeEnum.forSale}
      />
      <Spacer size={12} />
      <StyledHr color="neutral50" />
      <Spacer size={12} />
      <CheckboxInput
        name={ForSaleTypeEnum.inContract}
        checked={selectedForSaleTypes.includes(ForSaleTypeEnum.inContract)}
        onChange={() => handleCheckboxChange(ForSaleTypeEnum.inContract)}
        label={ForSaleTypeEnum.inContract}
      />
      <Spacer size={12} />
      <StyledHr color="neutral50" />
      <Spacer size={12} />
      <CheckboxInput
        name={ForSaleTypeEnum.sold}
        checked={selectedForSaleTypes.includes(ForSaleTypeEnum.sold)}
        onChange={() => handleCheckboxChange(ForSaleTypeEnum.sold)}
        label={ForSaleTypeEnum.sold}
      />
    </>
  )
}

export default ForSaleTypeSelectionInput
